import React from "react";
import InputSelectFloat from "../../inputs/InputSelectFloat";
import SocialMedia from "../../SocialMedia";
import { useListDepartmentsQuery } from "../../../services/public/departments";
import { useUpdateUserMutation } from "../../../services/organization/adminUsers";
import { useTranslation } from "react-i18next";

export default function About({ user }) {
  const { data: departmentsList } = useListDepartmentsQuery();
  const [updateUser] = useUpdateUserMutation();

  const { t } = useTranslation(["common", "employees"]);

  const socialMediaLinksAvailable =
    user?.facebook ||
    user?.instagram ||
    user?.linkedin ||
    user?.twitter ||
    user?.snapchat;

  return (
    <div className="profile-about">
      <div className="row">
        <div className="col-12 col-md-6 col-lg-3 mb-3">
          <InputSelectFloat
            label={t("employeeDepartment")}
            type="text"
            value=""
            onChange={(e) => {
              updateUser({
                userId: user?.id,
                updates: { department_id: e.target.value },
              });
            }}
          >
            <option defaultValue>{user?.department?.name}</option>
            {departmentsList?.data?.map(
              (department) =>
                department?.id != user?.department?.id && (
                  <option key={department?.id} value={department?.id}>
                    {department?.name}
                  </option>
                ),
            )}
          </InputSelectFloat>
        </div>

        <div className="col-12">
          <h1 className="font_20 font-extrabold mb-3">
            {t("socialMediaLinks")}
          </h1>
          {socialMediaLinksAvailable ? (
            <div className="mb-5">
              <SocialMedia
                url={{
                  facebook: user?.facebook,
                  instagram: user?.instagram,
                  linkedin: user?.linkedin,
                  twitter: user?.twitter,
                  snapchat: user?.snapchat,
                }}
              />
            </div>
          ) : (
            <p className="font_14 font-color-grey mb-5">{t("notExist")}</p>
          )}

          <h1 className="font_20 font-extrabold mb-3">
            {t("subscriptionDate")}
          </h1>
          <p className="font_14 font-color-grey mb-5">30 / 10 / 2022</p>

          <h1 className="font_20 font-extrabold mb-3">
            {t("lastActivitySince")}
          </h1>
          <p className="font_14 font-color-grey mb-5">
            4 {t("days")}
          </p>

          <h1 className="font_20 font-extrabold mb-3">
            {t("employees:noteAboutEmployee")}
          </h1>
          <p className="font_14 font-color-grey mb-5">
            {user?.bio ? user?.bio : t("notExist")}
          </p>

          <h1 className="font_20 font-extrabold mb-3">{t("theSkills")}</h1>
          <div className="d-flex flex-wrap align-center mb-5 gap-2">
            {user?.skills?.length > 0 ? (
              user?.skills?.map((skill) => (
                <span className="label label-grey" key={skill}>
                  {skill}
                </span>
              ))
            ) : (
              <p className="font_14 font-color-grey mb-0">{t("notExist")}</p>
            )}
          </div>

          <h1 className="font_20 font-extrabold mb-3">
            {t("employees:personalInfo")}
          </h1>
        </div>

        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <h2 className="font_14 font-bold font-color-grey mb-0">
            {t("mobileNumber")}
          </h2>
          <a
            dir="ltr"
            href={user?.phone ? `tel:${user.phone}` : undefined}
            className="font-16 font-extrabold"
          >
            {user?.phone ? user?.phone : t("notExist")}
          </a>
        </div>
        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <h2 className="font_14 font-bold font-color-grey mb-0">
            {t("theCountry")}
          </h2>
          <p className="font-16 font-extrabold mb-0">
            {user?.country?.name ? user?.country?.name : t("notExist")}
          </p>
        </div>
        <div className="col-6 col-md-4 col-lg-2 mb-3">
          <h2 className="font_14 font-bold font-color-grey mb-0">
            {t("theCity")}
          </h2>
          <p className="font-16 font-extrabold mb-0">
            {user?.city?.name ? user?.city?.name : t("notExist")}
          </p>
        </div>
      </div>
    </div>
  );
}
